export default function getErrorMessage(err: any) {
  if (err instanceof FrontError) return err.message;
  return "Une erreur est survenue :/";
}

export class FrontError extends Error {}
